
import { ActivityType } from './ActivityType';
import { COLORS } from '../../config/designSystem/Colors';
import { SolarBoltIcon } from '../../assets/images/solar/Bolt';
import { SolarChatSquareLikeIcon } from '../../assets/images/solar/ChatSquareLike';
import { SolarLaptopIcon } from '../../assets/images/solar/Laptop';
import { SolarLightbulbIcon } from '../../assets/images/solar/Lightbulb';
import { SolarMeditationIcon } from '../../assets/images/solar/Meditation';
import { SolarNotebookBookmarkIcon } from '../../assets/images/solar/NotebookBookmark';
import { SolarPaletteIcon } from '../../assets/images/solar/Palette';
import { SolarPenIcon } from '../../assets/images/solar/Pen';
import { SolarQuestionSquareIcon } from '../../assets/images/solar/QuestionSquare';
import { SolarWindIcon } from '../../assets/images/solar/Wind';



  type ActivityTypeProp = {
    type: ActivityType,
    size?: number,
    color?: string
  }

export const ActivityInfoIcon  = ({type, size = 16, color = COLORS.content.secondary}: ActivityTypeProp) => {




  switch (type) {
  case ActivityType.MEDITATION:
    return <SolarMeditationIcon color={color} size={size} />;
  case ActivityType.BREATHING:
    return <SolarWindIcon color={color} size={size} />;
  case ActivityType.TOOLING:
    return <SolarPaletteIcon color={color} size={size} />;
  case ActivityType.THINKING:
    return <SolarLightbulbIcon color={color} size={size} />;
  case ActivityType.ACTION:
    return <SolarBoltIcon color={color} size={size} />;
  case ActivityType.JOURNALING:
    return <SolarPenIcon color={color} size={size} />;
  case ActivityType.WEBINAR:
    return <SolarLaptopIcon color={color} size={size} />;
  case ActivityType.STORY:
    return <SolarChatSquareLikeIcon color={color} size={size} />;
  case ActivityType.SELF_ASSESSMENT:
    return  <SolarQuestionSquareIcon color={color} size={size} />;
  case ActivityType.LESSON:
    return  <SolarNotebookBookmarkIcon color={color} size={size} />;
  default:
    return <></>;
  }




};



